import React from "react";
import Footer from "../Comman/Footer";
import Header from "../Comman/Header";

const TermsConditions = () => {
  return (
    <>
    <Header/>
    <div className="relative min-h-screen bg-gray-50 py-20 px-6 overflow-hidden">

      {/* Soft Background Glow */}
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-[#a8721e]/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-[#a8721e]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto">

        {/* Header */}
        <div className="text-center mt-18 mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">
        Terms & Conditions – ZenoChain

          </h1>
          <div className="w-20 h-1 bg-[#a8721e] mx-auto mt-6 rounded-full"></div>
          <p className="mt-4 text-sm text-gray-500">
      <span className="font-medium text-black">
        Last Updated: 
        </span>  20th Feb 2026

          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white border border-gray-200 rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] p-10 md:p-14 space-y-12 text-gray-700 leading-relaxed text-[16px] transition-all duration-300 hover:shadow-[0_25px_70px_-15px_rgba(0,0,0,0.20)]">

          <p className="text-center">
      By accessing or using ZenoChain, you agree to these Terms & Conditions (“Terms”).
      <br />

If you do not agree, you must discontinue use immediately.

          </p>

          <p>
    
          </p>

          {/* Section Template */}
          {[
            {
              title: "1. Nature of ZenoChain",
              content: [
                <>ZenoChain is a <span className="font-bold">
                    decentralized blockchain network
                    </span> that enables on-chain transactions, smart contracts, and autonomous protocols.</>,
                <>ZenoChain does   <span className="font-bold"> not provide financial, investment, legal, or tax advice.</span></>
              ]
            },
            {
              title: "2. Eligibility",
              content: [
                "By using ZenoChain, you confirm that:",
                "You are legally permitted to use blockchain technology",
                "You understand the risks associated with digital assets",
                "You participate voluntarily and at your own discretion"
              ]
            },
            {
              title: "3. User Obligations",
              content: [
                "You agree to:",
                "Use ZenoChain lawfully and responsibly",
                "Maintain control of your wallet and private keys",
                "Understand that blockchain transactions are irreversible",
                "Accept all outcomes enforced by smart contracts"
              ]
            },
            {
              title: "4. Smart Contracts & Protocol Rules",
              content: [
                "All actions on ZenoChain are governed by smart contracts",
                "Rules, rewards, repayments, and penalties are enforced automatically",
                "ZenoChain does not manually intervene in transactions",
                "Users are responsible for understanding protocol mechanics before interacting."
              ]
            },
            {
              title: "5. Fees, Deductions & Network Rules",
              content: [
                "Network fees may apply to transactions",
                "Protocol-defined deductions or conditions may exist",
                "Failure to follow protocol rules may result in loss of eligibility or access"
              ]
            },
            {
              title: "6. Risks Disclosure",
              content: [
                "You acknowledge that:",
                "Blockchain technology involves technical risks",
                "Smart contracts may contain vulnerabilities",
                "Token values are volatile",
                "Regulatory environments may change",
                "You accept full responsibility for any losses incurred."
              ]
            },
            {
              title: "7. No Guarantees",
              content: [
                "ZenoChain makes no guarantees regarding:",
                "Network uptime",
                "Transaction success",
                "Token value or rewards",
                "Future protocol changes"
              ]
            },
            {
              title: "8. Limitation of Liability",
              content: [
                "To the fullest extent permitted by law, ZenoChain shall not be liable for:",
                "Financial losses",
                "Smart contract failures",
                "Network congestion or downtime",
                "Third-party actions or integrations",
                "Regulatory or legal changes"
              ]
            },
            {
              title: "9. Amendments",
              content: [
                "ZenoChain may update these Terms at any time.",
                " Continued use of the network constitutes acceptance of the updated Terms."
              ]
            },
            {
              title: "10. Governing Principle",
              content: [
                "These Terms operate under general principles of decentralized blockchain networks and applicable laws where enforceable."
              ]
            },
            {
              title: "11. Contact",
              content: [
                "For questions regarding these Terms, contact ZenoChain via official communication channels only."
              ]
            }
          ].map((section, index) => (
            <div key={index} className="group">
              <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
                <span className="w-2 h-8 bg-[#a8721e] rounded-sm group-hover:h-10 transition-all duration-300"></span>
                {section.title}
              </h2>

              <div className="space-y-3">
                {section.content.map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>

              {index !== 10 && (
                <div className="mt-10 border-t border-gray-100"></div>
              )}
            </div>
          ))}

        </div>
      </div>
    </div>
    <Footer/>
        </>
  );
};

export default TermsConditions;